import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from "react-router";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import Header from '../Components/Header';
import Sidebar from '../Components/Sidebar';
import { useProductStore } from '../store/useProductStore';
import { Box, Button, Modal, Pagination, Stack, TableCell, TableRow, Typography } from '@mui/material';
import Loader from '../Components/loader/Loader';

export default function Products() {
    const navigate = useNavigate()
    const { product, getProduct, deleteproduct, loading, DowloadProduct } = useProductStore()
    const [totalPages, setTotalPages] = useState(1);
    const [pageNumber, setPageNumber] = useState(1);
    const [search, setSearch] = useState('');
    const [itemId, setItemId] = useState(null);
    const [deleteId, setDeleteID] = useState(null);
    const [pageSize, setPageSize] = useState(10);
    const [field, setField] = useState('');
    const [open, setOpen] = useState(false);
    const [loadingStyle, setLoadingStyle] = useState(false);

    const handleCancelDelete = () => {
        setOpen(false);
    };

    const handleSearchChange = (e, field) => {
        setField(field)
        setPageNumber(1)
        // setLoading(true);
        setSearch(e.target.value)
    };

    const handleConfirmDelete = async () => {
        try {
            const res = await deleteproduct(deleteId)
            setOpen(false)
        } catch (error) {
            console.log(error)
        }
    }

    const handleDelete = (id) => {
        setDeleteID(id)
        setOpen(true)
    }

    const handleProductTable = async () => {
        setLoadingStyle(true)
        await DowloadProduct(pageNumber, pageSize, '', '')
        setLoadingStyle(false)
    }

    const handleChangePagination = (event, value) => {
        setPageNumber(value);
    };

    const handleEdit = (id) => {
        navigate(`/product/add?id=${encodeURIComponent(id)}`);
    };

    useEffect(() => {
        const getAllProductFunction = async () => {
            const data = await getProduct(pageNumber, pageSize, search, field)
            if (data) {
                setTotalPages(data?.totalPages)
            }
        }
        getAllProductFunction()
    }, [pageNumber, search, field])
    return (
        <div id="dashboard-root"
            className="flex min-h-[1000px] w-full">
            <Loader loading={loadingStyle} />
            {/* <!-- Sidebar --> */}
            <Sidebar />
            {/* <!-- Main Content --> */}
            <main id="main-content" className="flex-1 px-10 py-8">
                {/* <!-- Header --> */}
                <Header title="Products" />
                <div id="products-page" className="mb-6">
                    <div className="flex justify-between items-center mb-6">
                        <div>
                            {/* <h1 class="text-2xl font-bold text-gray-800">Products</h1> */}
                            <p className="text-gray-600">Manage your medical products inventory</p>
                        </div>
                        <div className="flex space-x-3">
                            <button className="bg-white border border-gray-300 rounded-lg px-4 py-2 text-sm font-medium text-gray-700 flex items-center">
                                <i className="fa-solid fa-filter mr-2"></i>
                                Filter
                            </button>
                            <button className="bg-white border border-gray-300 rounded-lg px-4 py-2 text-sm font-medium text-gray-700 flex items-center"
                                onClick={() => handleProductTable()}
                            >
                                <i className="fa-solid fa-download mr-2"></i>
                                Export
                            </button>
                            <Link to="/product/add" id="add-product-btn" class="bg-primary-600 hover:bg-primary-700 text-white rounded-lg px-4 py-2 text-sm font-medium flex items-center">
                                <i className="fa-solid fa-plus mr-2"></i>
                                Add Product
                            </Link>
                        </div>
                    </div>

                    <div className="bg-white rounded-lg shadow overflow-hidden">
                        <div className="p-4 border-b flex flex-row justify-between gap-2 ">
                            <div className="flex justify-start items-center">
                                <label htmlFor="" className=''>Product Name:-</label>
                                <input
                                    type="text"
                                    placeholder="Search Product"
                                    onChange={(e) => handleSearchChange(e, "name")}
                                    className="border rounded-lg px-3 py-2 text-sm w-auto ml-3"
                                />
                                {/* <i class="fa-solid fa-search absolute right-3 top-2.5 text-gray-400"></i> */}
                            </div>

                            <div className="flex justify-start items-center">
                                <label htmlFor="" className='mr-4'>SKU ID:-</label>
                                <input
                                    type="text"
                                    placeholder="Search SKUID"
                                    onChange={(e) => handleSearchChange(e, "sku_id")}
                                    className="border rounded-lg px-3 py-2 text-sm w-auto ml-3"
                                />
                            </div>

                            <div className="flex justify-start items-center">
                                <label htmlFor="" className='mr-4'>Brand Name:-</label>
                                <input
                                    type="text"
                                    placeholder="Search Brand"
                                    onChange={(e) => handleSearchChange(e, "brand")}
                                    className="border rounded-lg px-3 py-2 text-sm w-auto ml-3"
                                />
                            </div>
                        </div>
                        <div className="overflow-x-auto">
                            {
                                <table className="w-full">
                                    <thead className="bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        <tr>
                                            <th className="p-4">Image</th>
                                            <th className="p-4">Product</th>
                                            <th className="p-4">Brand</th>
                                            {/* <th class="p-4">Description</th> */}
                                            <th className="p-4">Category</th>
                                            <th className="p-4">SKU</th>
                                            <th className="p-4">Status</th>
                                            <th className="p-4">Actions</th>
                                        </tr>
                                        {/* <tr>
                                            <th>

                                            </th>
                                            <th class="p-4">
                                                <input
                                                    type="text"
                                                    placeholder="Search Product"
                                                    onChange={(e) => handleSearchChange(e, "name")}
                                                    class="mt-1 block w-full border border-gray-300 rounded-md p-1 text-sm"
                                                />
                                            </th>
                                            <th class="p-4">
                                                <input
                                                    type="text"
                                                    placeholder="Search Brand"
                                                    onChange={(e) => handleSearchChange(e, "brand")}
                                                    class="mt-1 block w-full border border-gray-300 rounded-md p-1 text-sm"
                                                />
                                            </th>
                                            <th class="p-4">
                                               
                                            </th>
                                            <th class="p-4">
                                                <input
                                                    type="text"
                                                    placeholder="Search SKUID"
                                                    onChange={(e) => handleSearchChange(e, "sku_id")}
                                                    class="mt-1 block w-full border border-gray-300 rounded-md p-1 text-sm"
                                                />
                                            </th>
                                            

                                        </tr> */}
                                    </thead>

                                    <tbody className="divide-y divide-gray-200">

                                        {
                                            loading ? (
                                                Array.from({ length: 5 }).map((_, rowIndex) => (
                                                    <TableRow key={rowIndex}>
                                                        {Array.from({ length: 8 }).map((_, colIndex) => (
                                                            <TableCell key={colIndex}>
                                                                <Skeleton variant="text" animation="wave" />
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                ))
                                            ) :
                                                ((product || []).map((ele, i) => (
                                                    <tr className="hover:bg-gray-50" key={i}>
                                                        {/* <td class="p-4">
                                                <input type="checkbox" class="rounded text-primary-600" />
                                            </td> */}
                                                        <td className="p-4">
                                                            <div className="flex items-center">
                                                                <div className="rounded-lg bg-gray-100 flex items-center justify-center  gap-3 ">
                                                                    {/* {ele?.images && ele.images.length > 0 && ( */}

                                                                    {/* // (ele.images || []).map((k, index) => ( */}
                                                                    <img
                                                                        src={ele.images[0]}
                                                                        alt="Product"
                                                                        className="w-16 h-16 object-cover rounded"
                                                                    />
                                                                    {/* // )) */}

                                                                    {/* // )} */}
                                                                </div>
                                                                <div>
                                                                    {/* <div class="font-medium text-gray-800">{ele?.name}</div> */}
                                                                    {/* <div class="text-xs text-gray-500">Pain Reliever</div> */}
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="p-4">
                                                            <div className="font-medium text-gray-800">{ele?.name}</div>
                                                        </td>
                                                        <td className="p-4 text-gray-600">{ele?.brand}</td>
                                                        {/* <td class="p-4 text-gray-600">{ele?.description}</td> */}
                                                        <td className="p-4 text-gray-600">{ele?.categoryName}</td>
                                                        <td className="p-4 text-gray-600">{ele?.sku_id}</td>
                                                        <td className="p-4">
                                                            {
                                                                ele?.is_featured ?
                                                                    <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs">Active</span> :
                                                                    <span className="px-2 py-1 bg-red-100 text-red-800 rounded-full text-xs">InActive</span>
                                                            }
                                                        </td>
                                                        <td className="p-4">
                                                            <div className="flex space-x-2">
                                                                <button className="text-gray-500 hover:text-primary-600"
                                                                    onClick={() => handleEdit(ele?._id)}>
                                                                    <i className="fa-solid fa-pencil"></i>
                                                                </button>
                                                                <button className="text-gray-500 hover:text-red-600"
                                                                    onClick={() => handleDelete(ele?._id)}>
                                                                    <i className="fa-solid fa-trash"></i>
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )))
                                        }
                                    </tbody>
                                </table>
                                || <Skeleton count={10} />}
                        </div>

                        <Modal
                            open={open}
                            onClose={handleCancelDelete}
                            aria-labelledby="confirm-delete-modal"
                            aria-describedby="modal-to-confirm-deletion"
                        >
                            <Box
                                sx={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    backgroundColor: 'white',
                                    padding: '20px',
                                    borderRadius: '5px',
                                    boxShadow: 24,
                                    width: { xs: "80%", md: "500px" },
                                    textAlign: 'center',
                                }}
                            >
                                <Typography variant="h6" gutterBottom>
                                    Are you sure you want to delete this Product?
                                </Typography>
                                <Button variant="outlined" color="#274156" onClick={handleConfirmDelete}>
                                    Yes
                                </Button>
                                <Button variant="outlined" color="#274156" onClick={handleCancelDelete} sx={{ marginLeft: '10px' }}>
                                    No
                                </Button>
                            </Box>
                        </Modal>
                        {/* <div class="p-4 border-t flex items-center justify-between">
                        <div class="text-sm text-gray-600">
                            Showing 1 to 5 of 42 entries
                        </div>
                        <div class="flex space-x-1">
                            <button class="px-3 py-1 rounded border text-gray-600 hover:bg-gray-50">Previous</button>
                            <button class="px-3 py-1 rounded border bg-primary-50 text-primary-600 font-medium">1</button>
                            <button class="px-3 py-1 rounded border text-gray-600 hover:bg-gray-50">2</button>
                            <button class="px-3 py-1 rounded border text-gray-600 hover:bg-gray-50">3</button>
                            <button class="px-3 py-1 rounded border text-gray-600 hover:bg-gray-50">Next</button>
                        </div>
                    </div> */}

                        <Stack spacing={2} className="flex items-end mt-4 ">
                            <Pagination
                                count={totalPages}
                                onChange={handleChangePagination}
                                variant="outlined"
                                shape="rounded"
                            />
                        </Stack>
                    </div>
                </div>
            </main>
        </div>
    )
}
